import script from "./ai-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-panel.vue?vue&type=script&setup=true&lang=ts"

import "./ai-panel.vue?vue&type=style&index=0&id=068534a4&lang=scss"

const __exports__ = script;

export default __exports__